import * as React from "react";
import Card from "@mui/material/Card";
import "../../../../theme.css";
import "./StopCard.css";
// import ReactReadMoreReadLess from 'react-read-more-read-less'
import ReactMoreReadLess from "../../../common/ReadMoreReadLess/ReactMoreReadLess";

import { v4 } from "uuid";
import {
  ChipTitle,
  dateDDMM,
  getImageUrlFromName,
  onlySpaces,
} from "../../../../util";
// import getCurrencySymbol from 'currency-symbol-map'
import guest from "../../../../assets/images/guest.svg";
import { stopViewModal } from "../../customerViewDataModel";
import { useSelector } from "react-redux";
import { fetchCurrentState } from "../../../../redux/features/customerViewSlice";
import calender_icon from "../../../../assets/images/icons/calender_icon.svg";
import booking_icon from "../../../../assets/images/icons/booking_icon.svg";
import bed_icon from "../../../../assets/images/icons/bed_icon.svg";
import confirmed_icon from "../../../../assets/images/icons/confirmed_icon.svg";
import { useNavigate } from "react-router-dom";
import SuggestedStops from "./SuggestedStops";
import { isEmpty } from "lodash";
import leisure from "../../../../assets/images/leisure-day.svg";
import ChipTag from "../../../common/ChipTag";
import defaultNote from "../../../../assets/images/icons/general-notes.png";
import TextTruncate from "react-text-truncate";
import { useEffect } from "react";
import {
  analyticsEvent,
  eventName,
} from "../../../common/Analytics/AnalyticsEvent";
import { NumericFormat } from "react-number-format";

function StopsCard(props) {
  console.log(">>>>>:: Stops Rendered");

  useEffect(() => {
    return () => {
      console.log("Stops >>> :: Unmounted");
    };
  }, []);

  const navigate = useNavigate();
  // const [showMore, setShowMore] = React.useState(false)
  // const tripStateData = useSelector(fetchCurrentState)
  const tripStateData = props.tripStateData;

  // console.log(tripStateData)
  const stopViewArrary = stopViewModal(tripStateData.trip_days);

  // console.log(stopViewArrary)

  return (
    <div>
      {stopViewArrary.map((day, id) => {
        return (
          <div key={v4()} style={{ marginBottom: "40px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                lineHeight: "0px",
              }}
            >
              <p className="headline1 truncated">
                Day {day.day}:{" "}
                <span
                  className="body3 "
                  style={{
                    lineHeight: "22.5px",
                  }}
                >
                  {day.place_title}
                </span>
                {/* <TextTruncate
                  line={1}
                  element="span"
                  truncateText="…"
                  text={day.place_title}
                  // text="Lorem Ipsum is simply dum sh shhsj sjsh"
                  containerClassName="body3"
                  style={
                    {
                      // color: 'white',
                      // lineHeight: '22.5px',
                    }
                  }
                /> */}
              </p>

              {day.date && (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={calender_icon}
                    style={{ marginRight: "5px" }}
                    alt="calender"
                  ></img>
                  <p className="headline1">{dateDDMM(day.date)}</p>
                </div>
              )}
            </div>
            {!isEmpty(day.stay_info) && (
              <div style={{ marginTop: "8px", marginBottom: "8px" }}>
                <div style={{ display: "flex", alignItems: "flex-start" }}>
                  {day.booking_status === "BOOKING_CONFIRMED" && (
                    <img
                      src={confirmed_icon}
                      style={{ marginRight: "5px", paddingTop: "10px" }}
                      alt="confirmed"
                    ></img>
                  )}
                  <img
                    src={bed_icon}
                    style={{ marginRight: "5px", paddingTop: "10px" }}
                    alt="bed_icon"
                  ></img>
                  <p className="body3" style={{ color: "var(--gray80)" }}>
                    {"Stay at " + day.stay_info}
                  </p>
                </div>
              </div>
            )}

            {!isEmpty(day.stopArr) ? (
              day.stopArr.map((itinerary, index) => {
                // console.log(itinerary)
                return (
                  <Card
                    sx={{
                      maxWidth: "100%",
                      margin: "15px 0px 25px 0px",
                      borderRadius: "8px",
                      // paddingRight: '3px',
                      marginTop: "7px",
                      border: "none",
                      boxShadow: "2px 4px 24px rgba(11, 12, 21, 0.1)",
                    }}
                    variant="outlined"
                    key={v4()}
                  >
                    <div className="inner-layer-stop">
                      <div
                        style={{
                          display: "flex",
                          lineHeight: "15px",
                          // justifyContent: "space-around",
                          // alignItems: "center",
                          margin: "0px 0px 16px",
                        }}
                      >
                        <div
                          className="stop-image-item"
                          style={{
                            width: "30%",
                            minWidth: "100px",
                            cursor: "pointer",
                            marginRight: "15px",
                            position: "relative",
                          }}
                          onClick={() => {
                            props.handleDetailPageOpen(
                              itinerary.item_id,
                              itinerary.is_default
                            );
                            analyticsEvent.clickEvent(
                              "Stops",
                              eventName.Stops_view_item_details,
                              `item_id: ${itinerary.item_id}, item_type: ${itinerary.item_type}, item_name: ${itinerary.place_title}, item_city: ${itinerary.city}`
                            );
                          }}
                        >
                          <img
                            style={{
                              borderRadius: "8px",
                              width: "100%",
                              // height: '70%',
                              alignSelf: "baseline",
                              marginTop: "15px",
                              aspectRatio: "6/5",
                            }}
                            alt="gallery"
                            src={itinerary.image}
                          ></img>
                          <div
                            style={{
                              position: "absolute",
                              left: "4px",
                              top: "20px",
                              zIndex: 2,
                            }}
                          >
                            <ChipTag
                              tagInfo={{
                                label:
                                  ChipTitle[itinerary.item_type] +
                                  " " +
                                  (index + 1),
                                bgColor: "white",
                                item_type: itinerary.item_type,
                              }}
                            />
                          </div>
                        </div>
                        <div
                          className="stop-details-item"
                          style={{ marginTop: "8px", width: "80%" }}
                        >
                          <div
                            onClick={() => {
                              props.handleDetailPageOpen(
                                itinerary.item_id,
                                itinerary.is_default
                              );
                              analyticsEvent.clickEvent(
                                "Stops",
                                eventName.Stops_view_item_details,
                                `item_id: ${itinerary.item_id}, item_type: ${itinerary.item_type}, item_name: ${itinerary.place_title}, item_city: ${itinerary.city}`
                              );
                            }}
                          >
                            {/* <p
                            className="headline2"
                            style={{ lineHeight: '22.5px', cursor: 'pointer' }}
                          >
                            {itinerary.place_title}
                          </p> */}
                            {itinerary.booking_status ===
                              "BOOKING_CONFIRMED" && (
                              <div style={{}}>
                                <p
                                  className="body3"
                                  style={{ color: "var(--statusSeaweedGreen)" }}
                                >
                                  <span
                                    style={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <img
                                      src={confirmed_icon}
                                      style={{ marginRight: "3px" }}
                                      alt="confirmed"
                                    ></img>
                                    Booking Confirmed
                                  </span>
                                </p>
                              </div>
                            )}
                            <TextTruncate
                              line={2}
                              element="p"
                              truncateText="…"
                              text={itinerary.place_title}
                              // text="Lorem Ipsum is simply dum sh shhsj sjsh"
                              containerClassName="headline2"
                              style={{
                                lineHeight: "22.5px",
                                cursor: "pointer",
                              }}
                            />
                            <p className="body3">
                              {itinerary.rating && (
                                <>
                                  <span
                                    style={{
                                      color: "var(--statusSeaweedGreen)",
                                    }}
                                  >
                                    &#9733; {itinerary.rating}
                                    &nbsp;
                                  </span>
                                  <span>&#x2022;&nbsp;</span>
                                </>
                              )}
                              {itinerary.activity_name && (
                                <span>{itinerary.activity_name}</span>
                              )}
                            </p>
                            {!isEmpty(itinerary.description) &&
                              !onlySpaces(itinerary.description) && (
                                <p
                                  className="body3 clamp"
                                  style={{
                                    color: "var(--gray80)",
                                    lineHeight: "22.5px",
                                    WebkitLineClamp: "2",
                                    margin: "0px",
                                  }}
                                >
                                  {itinerary.description}
                                </p>
                                // <TextTruncate
                                //   line={2}
                                //   element="p"
                                //   truncateText="…"
                                //   text={itinerary.description}
                                //   // text="Lorem Ipsum is simply dum sh shhsj sjsh"
                                //   containerClassName="body3"
                                //   style={{
                                //     color: 'var(--gray80)',
                                //     lineHeight: '22.5px',
                                //   }}
                                // />
                              )}
                            <span>
                              {itinerary.duration && (
                                <span className="body3">
                                  {itinerary.duration}
                                </span>
                              )}
                              {itinerary.total_guest && (
                                <span className="body4">
                                  &#x2022;&nbsp;
                                  <img
                                    src={guest}
                                    style={{
                                      width: "12px",
                                      height: "auto",
                                      display: "inline",
                                    }}
                                    alt="guest"
                                  ></img>
                                  {itinerary.total_guest}
                                </span>
                              )}
                              {itinerary.price && (
                                <span className="body3">
                                  &nbsp;&#x2022;{" "}
                                  <NumericFormat
                                    value={itinerary.price}
                                    thousandsGroupStyle="lakh"
                                    thousandSeparator=","
                                    displayType="text"
                                    renderText={(value) => (
                                      <span style={{ color: "var(--gray80)" }}>
                                        {itinerary.currency + value}
                                      </span>
                                    )}
                                  />
                                  <span
                                    className="body3"
                                    style={{ color: "var(--gray60)" }}
                                  >
                                    {" "}
                                    / person
                                  </span>
                                </span>
                              )}
                            </span>
                          </div>

                          {itinerary.booking_status === "BOOKING_CONFIRMED" && (
                            <div style={{ display: "flex" }}>
                              <img
                                src={booking_icon}
                                style={{ marginRight: "5px" }}
                                alt="booking_icon"
                              ></img>
                              <p
                                className="headline2"
                                style={{ color: "var(--primaryShades20)" }}
                              >
                                View Booking
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                      {/* {!isEmpty(itinerary.notes) && (
                      
                    )} */}
                      {itinerary.notes.map((note) => {
                        let iconURL = getImageUrlFromName(note.icon_name);
                        // console.log('>>>>>iconURL:: ', defaultNote)
                        let defaultURL = `"this.oneerror=null;this.src='${defaultNote};'"`;
                        // console.log(defaultURL)
                        return (
                          !isEmpty(note.value) && (
                            <div className="notes-div-stop" key={v4()}>
                              <div style={{ display: "inline-flex" }}>
                                <span>
                                  {/* <picture> */}
                                  {/* <source srcset={iconURL} type="image/png" /> */}
                                  <img
                                    src={iconURL}
                                    onerror={defaultURL}
                                    alt=""
                                    style={{
                                      width: "20px",
                                      height: "auto",
                                      marginTop: "5px",
                                    }}
                                  />
                                  {/* </picture> */}
                                  {/* <img
                                src={iconURL}
                                // alt="note-icon"
                                className="notes-icon"
                                style={{
                                  width: '25px',
                                  height: 'auto',
                                  marginTop: '5px',
                                }}
                              ></img> */}
                                </span>
                                <p
                                  className="body3 notes-para"
                                  style={{ color: "var(--gray100)" }}
                                >
                                  {/* <ReactReadMoreReadLess
                                    charLimit={70}
                                    readMoreText={'Read more ˅'}
                                    readLessText={'Read less ˄'}
                                    readMoreStyle={{
                                      color: '#00857D',
                                      cursor: 'pointer',
                                    }}
                                    readLessStyle={{
                                      color: '#00857D',
                                      cursor: 'pointer',
                                    }}
                                  >
                                    {note.value}
                                  </ReactReadMoreReadLess> */}
                                  <ReactMoreReadLess
                                    moreText={"Read more"}
                                    lessText={"Read less"}
                                    showArrow={true}
                                    top={"5px"}
                                    lines={"3"}
                                    analytics={true}
                                    analyticsProps={{
                                      page: "Stops",
                                      eventName: eventName.Stops_note_expanded,
                                    }}
                                  >
                                    {note.value}
                                  </ReactMoreReadLess>
                                </p>
                              </div>
                            </div>
                          )
                        );
                      })}
                    </div>
                    {!isEmpty(itinerary.suggestion_stops) && (
                      <div style={{ position: "relative" }}>
                        <SuggestedStops
                          items={itinerary.suggestion_stops}
                          handleDetailPageOpen={props.handleDetailPageOpen}
                        ></SuggestedStops>
                      </div>
                    )}
                  </Card>
                );
              })
            ) : (
              <Card
                sx={{
                  marginBottom: "16px",
                  marginTop: "7px",
                  borderRadius: "8px",
                  border: "none",
                  boxShadow: "2px 4px 24px rgba(11, 12, 21, 0.1)",
                }}
                variant="outlined"
              >
                <div style={{ display: "flex", padding: "15px" }}>
                  <img
                    src={leisure}
                    style={{ minWidth: "100px", minHeight: "82px" }}
                    alt="no-stay"
                  ></img>
                  <div>
                    <p
                      className="headline2"
                      style={{
                        margin: "0px 0px 0px 16px",
                        color: "var(--gray100)",
                      }}
                    >
                      Leisure day
                    </p>
                    <p
                      className="body3"
                      style={{
                        margin: "0px 0px 0px 16px",
                        color: "var(--gray80)",
                      }}
                    >
                      Relaxing time
                    </p>
                  </div>
                </div>
              </Card>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default StopsCard;
export const MemoizedStopCard = React.memo(StopsCard);
